import { CommandBarItem } from '@sketch/modules-common'

import { ReactComponent as AddCommentIcon } from '@sketch/icons/comment-chat-bubble-plus-17'

interface CreateAddAnnotationCommandsProps {
  isInspectorActive: boolean
  isViewingLatestVersion: boolean
  setPlaceDraftAnnotation: (value: boolean) => void
}

export const createAddAnnotationCommands = ({
  isInspectorActive,
  isViewingLatestVersion,
  setPlaceDraftAnnotation,
}: CreateAddAnnotationCommandsProps): CommandBarItem[] => {
  if (!isViewingLatestVersion) {
    return []
  }

  return [
    {
      id: 'document.add-annotation',
      analyticsId: 'document.add-annotation',
      kind: 'command',
      title: 'Add a comment',
      disabledReason: isInspectorActive
        ? 'You cannot add a comment while inspecting'
        : undefined,
      shortcut: 'N',
      section: 'Current Document',
      keywords: ['new', 'add', 'comment', 'annotation'],
      icon: AddCommentIcon,
      priority: 20,
      run: () => setPlaceDraftAnnotation(true),
    },
  ]
}
